/**
 * Legacy payload normalization — not imported by API routes or lightweight resolvers.
 */
import { legacyContentToRichTextBlocks } from '@/lib/scroll-preview'
import { createEmptyTabsBlockData, normalizeTabsBlockData } from '../models/tabs-model'
import { normalizeRichTextBlocks } from '../models/richtext-blocks-normalize'
import { normalizeJourneyTimelineData } from '../models/journey-timeline-model'
import { normalizeInsightData } from '../Blocks/insight/insight-model'
import { getBlockDefaultData } from './blocks-registry-defaults'
import { resolveBlockType } from './blocks-registry-resolve'

/**
 * Normalize persisted legacy payloads into block-friendly shapes.
 */
export function migrateSectionPayload(type, data) {
  const blockType = resolveBlockType(type)
  const d = data && typeof data === 'object' ? { ...data } : {}

  if (blockType === 'block_richtext') {
    if (Array.isArray(d.blocks)) {
      return { blocks: normalizeRichTextBlocks(d.blocks) }
    }
    if (typeof d.content === 'string' && d.content.trim()) {
      return {
        blocks: legacyContentToRichTextBlocks(d.content, () =>
          crypto.randomUUID(),
        ),
      }
    }
    return { blocks: [] }
  }

  if (blockType === 'block_callout') {
    const icon =
      typeof d.icon === 'string' && !d.icon.includes('💡')
        ? d.icon
        : 'idea'
    return {
      icon,
      color: d.color ?? 'purple',
      content: d.content ?? d.body ?? '',
    }
  }

  if (blockType === 'block_insight') {
    return normalizeInsightData(d)
  }

  if (blockType === 'block_steps' && Array.isArray(d.steps)) {
    return { steps: d.steps }
  }

  if (blockType === 'block_summary' && Array.isArray(d.summaries)) {
    return { summaries: d.summaries }
  }
  if (blockType === 'block_question' && Array.isArray(d.questions)) {
    return { questions: d.questions }
  }
  if (blockType === 'block_reference' && Array.isArray(d.references)) {
    return { references: d.references }
  }
  if (blockType === 'block_timeline') {
    return normalizeJourneyTimelineData(d)
  }

  if (blockType === 'block_tabs') {
    return normalizeTabsBlockData(d)
  }

  if (blockType === 'block_quote') {
    if (typeof d.text === 'string') return { ...getBlockDefaultData(blockType), ...d }
    if (Array.isArray(d.quotes) && d.quotes[0]) {
      return { ...getBlockDefaultData(blockType), text: d.quotes[0] }
    }
  }

  const defaults = getBlockDefaultData(blockType)
  return Object.keys(d).length ? { ...defaults, ...d } : defaults
}

// Re-export for callers that need empty tabs without full registry
export { createEmptyTabsBlockData }
